import { render, staticRenderFns } from "./OptionTypeAddValueModal.vue?vue&type=template&id=61ab88aa&"
import script from "./OptionTypeAddValueModal.vue?vue&type=script&lang=js&"
export * from "./OptionTypeAddValueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports